import ReportsTemplate from '../../../components/Templates/Reports/ReportsTemplate';

/**
 * @page Task.tsx
 * @description Management module to assign a Task.
 * @return { page }
 */
function Reports() {
  return <ReportsTemplate />;
}

export default Reports;
